export enum IauiBettingLimitModalState {
	OPEN,
	CLOSED,
}

export interface IauiBettingLimitState {
	modalState: IauiBettingLimitModalState;
	isModalShown: boolean;
}
